var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.126 20.489v1.125H3.75v-1.125h16.376zM14.986 2.25l5.367 5.524-2.242 2.242c-.013.016-.02.037-.035.052l-.016.013-.036.021-8.829 8.83H3.75v-5.446l8.83-8.829c.012-.016.018-.037.034-.052l.025-.018.027-.016 2.32-2.321zM13.02 5.807l-8.145 8.145v3.854h3.854l8.146-8.145-3.855-3.854zm1.955-1.955-1.16 1.16 3.855 3.854 1.103-1.103-3.798-3.91z",
  fill: "#2F3033",
  fillRule: "evenodd"
})));
export default SvgEdit;